import { ReactNode } from 'react'
import { WithClassName } from 'shared/types/general.types'
import { cn } from 'utils/style'

type EmptyStateProps = WithClassName<{
	icon: ReactNode
	text: string
	description?: string
}>

export const EmptyState = ({ icon, text, description, className }: EmptyStateProps) => (
	<div
		className={cn(
			'flex min-h-[8rem] flex-col items-center justify-center px-5 py-8 text-center',
			className
		)}>
		<span className="grid h-10 w-10 place-items-center rounded-full bg-muted text-muted-foreground [&>svg]:h-4 [&>svg]:w-4 [&>svg]:stroke-2">
			{icon}
		</span>
		<p className="mt-3 text-[13px] font-semibold">{text}</p>
		{description ? <p className="mt-1 text-[12px] text-muted-foreground">{description}</p> : null}
	</div>
)
